import withUserSession, { InjectedUserSessionProps } from "hooks/with-user-session";
import type { JSX } from 'react';
import { Navigate } from "react-router-dom";
import withRouting, { useRouting } from "../../hooks/with-routing";

type ProtectedRouteProps = InjectedUserSessionProps & {
	children: JSX.Element;
};

const ProtectedRoute = ({ userSession, children }: ProtectedRouteProps) => {
	const createPath = useRouting.use.createPath();

	if (userSession.isAuthenticated) {
		return children;
	}

	const to = createPath("/:segmento/login");
	return <Navigate to={to} replace />;
};

export default withRouting(withUserSession(ProtectedRoute), "/404");